import * as React from "react";

export const BoxLabel: React.FC = ({ children }) => (
  <span className="text-[11px] font-semibold text-[#94a3b8] whitespace-nowrap">{children}</span>
);
